import React, { useState, useEffect } from "react";

//* import mui
import { Avatar, Box } from "@mui/material";
import CircleIcon from '@mui/icons-material/Circle';
import CircularProgress from '@mui/material/CircularProgress';

//* import css
import cssClasses from "./NotificationDrawer.module.css";

//* import service
import { getLeadNotificationByCpId_actionWithPagination, updateLeadNotification } from "../../Services/NotificationService";
import { errorTost, offlineToast } from "../../Services/Toast";

//* import npm
import InfiniteScroll from 'react-infinite-scroll-component';
import ReactTimeAgo from "react-time-ago";
import { useSelector } from "react-redux";
import { supabase } from "../../supabaseClient";
import { Network } from '@capacitor/network';

// import assets
import EmptyIcon from '../../Assets/Images/EmptyDataIcons/EnablePushNotifications@3x.svg';
const action = "converted";
function LeadConverterNotification({ clearLeadNotification }) {

  const loggedInUser = useSelector((state) => state.Auth.user);

  const [notification, setNotification] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    let leadNotificationsListener = null;
    if (loggedInUser) {
      Network.getStatus().then(netWorkResponse => {
        if (netWorkResponse.connected) {
          getNotificationFromServer(0, 9, false);
          leadNotificationsListener = supabase.from(`LeadNotifications:${loggedInUser.type === "CP" ? "cpId" : "fosId"}=eq.${loggedInUser.type === "CP" ? loggedInUser.cpId : loggedInUser.fosId}`).on('INSERT', payload => {
            if (payload.eventType === "INSERT") {
              console.log('Change received!', payload)
              // setEventNotificationCount(pre => pre+1);
              supabase.from("LeadNotifications").select("*, eventId(*), userId(*), leadId(* , personId(*)), allotmentPaymentId(*, unitId(*, projectId(*)))").eq("leadNotificationId", payload.new.leadNotificationId).single().then(res => {
                if (res.data) {
                  setNotification(pre => [{ ...payload.new }, ...pre]);
                }
              })
            }
          }).subscribe((status, r) => {
            console.log({ status, r });
          });
        }
      });
    }

    return () => {
      if (leadNotificationsListener) {
        supabase.removeSubscription(leadNotificationsListener);
        leadNotificationsListener = null;
      }
    }
  }, [])

  useEffect(() => {
    if (notification.some(s => !s.isRead)) {
      console.log("Go to update Notification");
      Promise.all(notification.filter(s => !s.isRead).map(m => updateLeadNotification({ isRead: true }, m.leadNotificationId))).then(res => {
        console.log(res);
      }).catch(err => {
        console.error(err);
      })
    }
    clearLeadNotification();
  }, [notification])


  async function getNotificationFromServer(_to, _from, merge) {
    try {
      setIsLoading(true);
      const getEventNotificationWithPaginationResponse = await getLeadNotificationByCpId_actionWithPagination(loggedInUser.type === "CP" ? "cpId" : "fosId", loggedInUser.type === "CP" ? loggedInUser.cpId : loggedInUser.fosId, action, _to, _from);
      console.log("getEventNotificationWithPaginationResponse => ", getEventNotificationWithPaginationResponse);
      if (getEventNotificationWithPaginationResponse.data) {
        if (merge) {
          setNotification([...notification, ...getEventNotificationWithPaginationResponse.data]);
          // setNotification([...notification, ...Array(10).fill("")]);
        } else {
          setNotification([...getEventNotificationWithPaginationResponse.data]);
          // setNotification([...Array(10).fill("")]);
        }
        if (getEventNotificationWithPaginationResponse.count === (notification.length + getEventNotificationWithPaginationResponse.data.length)) {
          setHasMore(false);
        }
      } else {
        if (getEventNotificationWithPaginationResponse?.error?.message) {
          errorTost(getEventNotificationWithPaginationResponse.error.message);
        } else {
          errorTost("Something went wrong! Try again");
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      errorTost("Something went wrong! Try again");
      setIsLoading(false);
    }

  }

  function loadMore() {
    Network.getStatus().then((resp) => {
      if (resp.connected) {
        getNotificationFromServer(notification.length, ((notification.length + 10) - 1), true);
      } else {
        offlineToast();
      }
    });
  }

  function refreshNotification() {
    Network.getStatus().then((resp) => {
      if (resp.connected) {
        getNotificationFromServer(0, 9, false);
      } else {
        offlineToast();
      }
    });
  }

  return (
    <div className={cssClasses.notificationContainerWrapper} id={`scrollableDiv_EventUpdateNotification`}>
      {(isLoading && notification.length === 0) ?
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"} flex={1}>
          <CircularProgress />
        </Box>
        :
        <>
          {(notification.length > 0) ?

            <InfiniteScroll
              dataLength={notification.length} //This is important field to render the next data
              next={loadMore}
              style={{ display: "flex", flexDirection: "column" }}
              hasMore={hasMore}
              loader={<p className={cssClasses.infiniteScrollLoadingText}>Loading...</p>}
              scrollableTarget={`scrollableDiv_EventUpdateNotification`}
              endMessage={
                <p className={cssClasses.infiniteScrollLoadingText}>
                  {(notification.length > 10) && <b>Yay! You have seen it all notification</b>}
                </p>
              }
              below props only if you need pull down functionality
              refreshFunction={refreshNotification}
              pullDownToRefresh
              pullDownToRefreshThreshold={50}
              pullDownToRefreshContent={
                <h3 style={{ textAlign: 'center' }}>&#8595; Pull down to refresh</h3>
              }
              releaseToRefreshContent={
                <h3 style={{ textAlign: 'center' }}>&#8593; Release to refresh</h3>
              }
            >
              {
                notification.map((notificationItem, notificationIndex) => (
                  <div key={`notification_${notificationIndex}`} className={cssClasses.notificationContainer}>
                    <div className={cssClasses.notificationAvatarWrapper}><Avatar src="" /></div>
                    <div className={cssClasses.notificationTextWrapper}>
                      <p className={`${cssClasses.notificationText} ${cssClasses.notificationHeaderText}`}> {`${notificationItem.leadId.personId.name}`} <span className={`${cssClasses.notificationText} ${cssClasses.notificationTimeText}`}><ReactTimeAgo date={notificationItem.created_at} locale="en-US" /></span></p>

                      {/* <p className={`${cssClasses.notificationText} ${cssClasses.notificationSubHeaderText}`}>{notificationItem.action === "claimed" ? "Your Lead Got claimed" : notificationItem.action} </p> */}
                      <p className={`${cssClasses.notificationText} ${cssClasses.notificationSubHeaderText}`}>Your Lead booked a Flat</p>
                      {/* {notificationItem.action === "added" ?
                          <p className={`${cssClasses.notificationText} ${cssClasses.notificationDescriptionText}`}>{`“${notificationItem.eventId.title} event added recently. Please check the details”`}</p>
                        :
                          <p className={`${cssClasses.notificationText} ${cssClasses.notificationDescriptionText}`}>{`“${notificationItem.action} changed for ${notificationItem.eventId.title}”`}</p>
                      } */}
                      <p className={`${cssClasses.notificationText} ${cssClasses.notificationDescriptionText}`}>{`“${notificationItem.leadId.personId.name} booked an unit at ${notificationItem.allotmentPaymentId.unitId.projectId.projectName} on 12/12/2022. ”`}</p>
                    </div>
                    {!notificationItem.isRead &&
                      <div>
                        <CircleIcon style={{ color: "#12B76A" }} />
                      </div>
                    }
                  </div>
                ))
              }
            </InfiniteScroll>
            :
            // <Box display={"flex"} justifyContent={"center"} alignItems={"center"} flex={1}>
            //   <p className={cssClasses.noNotificationText}>No notification yet!</p>
            // </Box>
            <Box display={"flex"} justifyContent={"center"} alignItems={"center"} flex={1} className={cssClasses.noDataMsg}>
              {/* <p className={cssClasses.noNotificationText}>No notification yet!</p> */}
              <div className={cssClasses.noDataMsg}>
                <div className={cssClasses.emptyIcon}>
                  <img src={EmptyIcon} alt="No Notifications" />
                </div>
                <div className={cssClasses.emptyTitle}>No Notifications</div>
                <div className={cssClasses.emptySubTitle}>
                  You have recieved no notifications.
                </div>
              </div>
            </Box>
          }
        </>
      }
    </div>
  )
}

export default LeadConverterNotification